import { MappedAnswer } from '../components/context/SurveyPageContext';
import env from '../config/env';
import DynamicTextDTO from '../interfaces/dto/dynamicTextDTO';
import SurveyDTO from '../interfaces/dto/surveyDTO';
import type { SanityList } from '../interfaces/dto/swapCreditModalContent';
import { get, post, put } from '../utils/api';
import { apiPaths } from '../utils/apiPaths';
import { redirectToDashboard } from '../utils/redirectMethods';

/* GET */
const getCancelFlow = async (): Promise<SurveyDTO[]> => {
  const url = apiPaths.getCancelFlow;
  const { data, status } = await get(env.QUESTIONNAIRE_API_URL, url);
  if (status === 204) {
    redirectToDashboard();
    throw new Error('Cancel Flow is not present!');
  } else if (status === 200 && data.length === 0) {
    redirectToDashboard();
    throw new Error('Cancel Flow is empty!');
  }
  return data;
};

const getDynamicText = async (): Promise<DynamicTextDTO> => {
  const url = apiPaths.getDynamicText;
  return get(env.QUESTIONNAIRE_API_URL, url).then((response) => response.data);
};

/* POST */
const postQuestionnaireAnswers = async (answers: MappedAnswer[]): Promise<void> => {
  const url = apiPaths.postQuestionnaireAnswers;
  return post(env.QUESTIONNAIRE_API_URL, answers, url).then((response) => response.data);
};

const postCancelSubscription = async (): Promise<void> => {
  const url = apiPaths.postCancelSubscription;
  return post(env.QUESTIONNAIRE_API_URL, {}, url).then((response) => response.data);
};

const postSkipBox = async (): Promise<void> => {
  const url = apiPaths.postSkipBox;
  return post(env.QUESTIONNAIRE_API_URL, {}, url).then((response) => response.data);
};

/* PUT */
const putReactivateSubscription = async (): Promise<unknown> => {
  const url = apiPaths.putReactivateSubscription;
  return put(env.QUESTIONNAIRE_API_URL, {}, url).then((response) => response.data);
};

const getSwapCreditTextContent = async (): Promise<SanityList> => {
  try {
    const url = `${apiPaths.getSanityList}/swap-credit-modal`;
    const { data } = await get(env.ASADO_URL, url);
    return data;
  } catch (_) {
    console.error(_);
    return [];
  }
};

export {
  getCancelFlow,
  getDynamicText,
  postQuestionnaireAnswers,
  postCancelSubscription,
  postSkipBox,
  putReactivateSubscription,
  getSwapCreditTextContent,
};
